
import { mapGetters } from "vuex";
import { getCombinedWLPageQueryParam } from "@utils";
import { PAGES } from "@consts";

export default {
	name: "WordleCTA",
	props: {
		cssClass: {
			type: String,
			default: "",
		},
	},
	computed: {
		...mapGetters("navigation", ["isWordleResultsPage"]),
		wordleUrl() {
			const WORD_LENGTH = 5;

			const base = "/wordle/results/";
			const fallback = "/wordle/";
			const params = new URLSearchParams();

			let startsLower = "";
			let endsLower = "";
			let containsLower = "";

			if (
				this.$route.name ===
				PAGES.WORDS_COMBINATION_LENGTH_AND_LETTERS_RESULTS
			) {
				startsLower =
					getCombinedWLPageQueryParam(
						this.$route.params.advanced,
						"starts"
					) || "";
				endsLower =
					getCombinedWLPageQueryParam(
						this.$route.params.advanced,
						"ends"
					) || "";
				containsLower =
					getCombinedWLPageQueryParam(
						this.$route.params.advanced,
						"with"
					) || "";
			} else {
				startsLower = this.$route.query.starts || "";
				endsLower = this.$route.query.ends || "";
				containsLower = this.$route.query.contains || "";
			}

			const middleLength =
				WORD_LENGTH - startsLower.length - endsLower.length;

			if (middleLength < 0) {
				// starts + ends overflow 5 chars then everything goes to includes
				const includes = (
					startsLower +
					endsLower +
					containsLower
				).slice(0, WORD_LENGTH);
				if (includes) {
					params.set("includes", includes);
				}
			} else {
				const correct =
					startsLower + "_".repeat(middleLength) + endsLower;
				if (correct !== "_".repeat(WORD_LENGTH)) {
					params.set("correct", correct);
				}
				if (containsLower) {
					params.set("includes", containsLower);
				}
			}

			const queryString = params.toString();
			return queryString ? `${base}?${queryString}` : fallback;
		},
	},
	methods: {
		onClick() {
			if (!this.isWordleResultsPage) {
				this.$store.dispatch("tracking/trackEvent", {
					eventCategory: "Wordle CTA",
					eventAction: "Click Wordle CTA button",
				});
			}
		},
	},
};
